import { AlpineComponent } from 'alpinejs';

type TagButtonsComponent = {
  isDesktop: boolean;
  dotsWidth: number;
  onResize: () => Promise<void>;
};

const TagButtons = (): AlpineComponent<TagButtonsComponent> => ({
  isDesktop: false,

  get dotsWidth() {
    return this.isDesktop ? 64 : 56;
  },

  async onResize() {
    const dots = this.$root.querySelector('.tag-buttons__dots');
    if (dots) {
      this.$root.removeChild(dots);
    }

    const tags = this.$root.querySelectorAll<HTMLElement>(
      '.tag-buttons__button'
    );

    const { top } = this.$root.getBoundingClientRect();

    // find first overflowing tag
    for (let i = 0; i < tags.length; i += 1) {
      const t = tags[i];
      const tBB = t.getBoundingClientRect();

      if (top < tBB.top) {
        const dotsTmpl = this.$refs.dots as HTMLTemplateElement;
        const dots = dotsTmpl.content.cloneNode(true);
        this.$root.insertBefore(dots, t);
        break;
      }
    }
  }
});

export default TagButtons;
